import React from 'react';
import NavBarHome from '../../components/NavBar/NavBarHome';
import Masthead from './Masthead';
import Footer from '../../components/Footer/Footer';
import PricingSection from './PricingSection';
import AnimatedSection from '../../components/Animation/AnimatedSection';
import AOSInit from '../../components/Animation/AOSInit';
import HowItWorks from './HowItWorks/HowItWorks';
import TopCategories2 from './TopCategories2';
import WhyChooseGoNextMaker from './WhyChooseGoNextMaker';
import CoursesByLeaders from './CoursesByLeaders';
import StudentTestimonials from './StudentTestimonials/StudentTestimonials';
import JoinLearners from './JoinLearners';

function Home() {
  return (
    <div className="pt-[92px] flex flex-col min-h-screen overflow-x-hidden">
      <AOSInit />
      <NavBarHome />

      {/* Hero Section */}
      <section id="hero" className="relative">
        <AnimatedSection
          animation="fade-up"
          duration={1200}
          delay={100}
          threshold={1.0}
        >
          <Masthead />
        </AnimatedSection>
      </section>

      {/* Top Categories */}
      <section id="categories" className="">
        <AnimatedSection
          animation="fade-up"
          duration={800}
          delay={200}
          threshold={1.0}
        >
          <TopCategories2 />
        </AnimatedSection>
      </section>

      {/* Pricing */}
      <section id="pricing" className="bg-light-5">
        <AnimatedSection
          animation="fade"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <PricingSection />
        </AnimatedSection>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="">
        <AnimatedSection
          animation="fade-up"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <HowItWorks />
        </AnimatedSection>
      </section>

      {/* Why Choose GoNextMaker */}
      <section id="why-choose-gonextmaker" className="">
        <AnimatedSection
          animation="fade-up"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <WhyChooseGoNextMaker />
        </AnimatedSection>
      </section>

      {/* Top Instructors */}
      <section id="instructors" className="">
        <AnimatedSection
          animation="fade"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <CoursesByLeaders />
        </AnimatedSection>
      </section>

      {/* Top Students */}
      <section id="students" className="">
        <AnimatedSection
          animation="fade-down"
          duration={800}
          delay={200}
          threshold={1.0}
        >
          <StudentTestimonials />
        </AnimatedSection>
      </section>

      {/* Recommendations */}
      <section id="recommendations">
        <AnimatedSection
          animation="fade"
          duration={1000}
          delay={200}
          threshold={1.0}
        >
          <JoinLearners />
        </AnimatedSection>
      </section>

      {/* Footer */}
      <section id="footer">
        <Footer
          logo={"/Logo NextMaker.png"}
          bgColor="bg-[#140342]"
          textColor="text-white"
          borderColor="border-gray-400/20"
        />
      </section>
    </div>
  );
}

export default Home;